import React, { useEffect, useState } from 'react';
import { LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
const CORRECT_PASSWORD = 'creditual2025'; // Cambiar esta contraseña según necesites
export function PitchPage() {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  // Verificar si ya está autenticado en sessionStorage
  useEffect(() => {
    const auth = sessionStorage.getItem('pitch-authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('pitch-authenticated', 'true');
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };
  // Pantalla de login
  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gradient-to-br from-[#0A1628] via-[#1a2942] to-[#0A1628] flex items-center justify-center p-4" data-id="element-456">
        <div className="w-full max-w-md" data-id="element-457">
          {/* Logo */}
          <div className="text-center mb-8" data-id="element-458">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#2B5FD9] mb-4" data-id="element-459">
              <LockIcon className="h-8 w-8 text-white" data-id="element-460" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2" data-id="element-461">
              Creditual Pitch
            </h1>
            <p className="text-sm text-gray-400" data-id="element-462">Contenido protegido</p>
          </div>

          {/* Form */}
          <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 shadow-2xl" data-id="element-463">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-464">
              <div data-id="element-465">
                <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-466">
                  Contraseña de acceso
                </label>
                <div className="relative" data-id="element-467">
                  <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                  setPassword(e.target.value);
                  setError(false);
                }} className={`w-full px-4 py-3 bg-white/10 border ${error ? 'border-red-500' : 'border-white/20'} rounded-xl text-white placeholder-gray-500 outline-none focus:border-[#2B5FD9] focus:ring-2 focus:ring-[#2B5FD9]/20 transition-all`} placeholder="Ingresa la contraseña" autoFocus data-id="element-468" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors" data-id="element-469">
                    {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-470" /> : <EyeIcon className="h-5 w-5" data-id="element-471" />}
                  </button>
                </div>
                {error && <p className="mt-2 text-sm text-red-400" data-id="element-472">
                    Contraseña incorrecta. Inténtalo de nuevo.
                  </p>}
              </div>

              <button type="submit" className="w-full px-6 py-3 bg-[#2B5FD9] text-white font-semibold rounded-xl hover:bg-[#1E4BB8] transition-colors shadow-lg hover:shadow-xl" data-id="element-473">
                Acceder
              </button>
            </form>
          </div>

          {/* Footer */}
          <p className="text-center text-xs text-gray-500 mt-6" data-id="element-474">
            Si no tienes acceso, contacta al equipo de Creditual
          </p>
        </div>
      </div>;
  }
  // Contenido del pitch (después de autenticarse)
  return <div className="min-h-screen bg-white" data-id="element-475">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-476">
        <div className="container mx-auto max-w-7xl px-6 py-4" data-id="element-477">
          <div className="flex items-center justify-between" data-id="element-478">
            <div className="flex items-center gap-3" data-id="element-479">
              <div className="w-10 h-10 rounded-xl bg-[#2B5FD9] flex items-center justify-center" data-id="element-480">
                <span className="text-white font-bold text-lg" data-id="element-481">C</span>
              </div>
              <div data-id="element-482">
                <h1 className="text-xl font-bold text-[#0A1628]" data-id="element-483">Creditual</h1>
                <p className="text-xs text-[#6B7280]" data-id="element-484">Pitch Deck</p>
              </div>
            </div>
            <button onClick={() => {
            sessionStorage.removeItem('pitch-authenticated');
            setIsAuthenticated(false);
            setPassword('');
          }} className="text-sm text-[#6B7280] hover:text-[#0A1628] transition-colors" data-id="element-485">
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      {/* Contenido del Pitch */}
      <div className="container mx-auto max-w-5xl px-6 py-12" data-id="element-486">
        {/* Slide 1: Problema */}
        <section className="mb-16" data-id="element-487">
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 md:p-12 border border-red-100" data-id="element-488">
            <span className="inline-block px-3 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded-full mb-4" data-id="element-489">
              EL PROBLEMA
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-490">
              Obtener un crédito hipotecario en Chile es lento, confuso y
              frustrante
            </h2>
            <div className="space-y-4" data-id="element-491">
              <div className="flex items-start gap-3" data-id="element-492">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-493">
                  <span className="text-white font-bold" data-id="element-494">1</span>
                </div>
                <div data-id="element-495">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-496">
                    Proceso lento (4-6 semanas)
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-497">
                    Los compradores esperan semanas para saber si califican,
                    perdiendo oportunidades.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-498">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-499">
                  <span className="text-white font-bold" data-id="element-500">2</span>
                </div>
                <div data-id="element-501">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-502">
                    Falta de claridad
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-503">
                    No saben cuánto pueden pedir ni qué banco les conviene hasta
                    muy tarde en el proceso.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-504">
                <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-505">
                  <span className="text-white font-bold" data-id="element-506">3</span>
                </div>
                <div data-id="element-507">
                  <h3 className="font-bold text-[#0A1628] mb-1" data-id="element-508">
                    Múltiples postulaciones
                  </h3>
                  <p className="text-[#6B7280]" data-id="element-509">
                    Deben postular banco por banco, repitiendo el mismo proceso
                    una y otra vez.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 2: Solución */}
        <section className="mb-16" data-id="element-510">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 border border-blue-100" data-id="element-511">
            <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs font-semibold rounded-full mb-4" data-id="element-512">
              LA SOLUCIÓN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-513">
              Creditual: Tu mejor crédito hipotecario en días, no semanas
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-514">
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-515">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-516">
                  <span className="text-white text-2xl font-bold" data-id="element-517">1</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-518">
                  Un solo formulario
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-519">
                  Completa tus datos una vez y evalúa en múltiples bancos
                  simultáneamente.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-520">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-521">
                  <span className="text-white text-2xl font-bold" data-id="element-522">2</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-523">
                  Resultados en 24-48h
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-524">
                  Sabes cuánto puedes pedir y qué bancos te aprueban en días.
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-525">
                <div className="w-12 h-12 rounded-xl bg-[#2B5FD9] flex items-center justify-center mb-4" data-id="element-526">
                  <span className="text-white text-2xl font-bold" data-id="element-527">3</span>
                </div>
                <h3 className="font-bold text-[#0A1628] mb-2" data-id="element-528">
                  100% transparente
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-529">
                  Comparas tasas, plazos y condiciones para elegir tu mejor
                  opción.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 3: Mercado */}
        <section className="mb-16" data-id="element-530">
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 md:p-12 border border-green-100" data-id="element-531">
            <span className="inline-block px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full mb-4" data-id="element-532">
              OPORTUNIDAD DE MERCADO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-533">
              Un mercado enorme y en crecimiento
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-534">
              <div data-id="element-535">
                <div className="mb-6" data-id="element-536">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-537">
                    $50B+
                  </p>
                  <p className="text-[#6B7280]" data-id="element-538">
                    Créditos hipotecarios colocados anualmente en Chile
                  </p>
                </div>
                <div className="mb-6" data-id="element-539">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-540">80K+</p>
                  <p className="text-[#6B7280]" data-id="element-541">
                    Operaciones de crédito hipotecario al año
                  </p>
                </div>
              </div>
              <div data-id="element-542">
                <div className="mb-6" data-id="element-543">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-544">15+</p>
                  <p className="text-[#6B7280]" data-id="element-545">
                    Instituciones financieras compitiendo por clientes
                  </p>
                </div>
                <div data-id="element-546">
                  <p className="text-6xl font-bold text-[#2B5FD9] mb-2" data-id="element-547">0</p>
                  <p className="text-[#6B7280]" data-id="element-548">
                    Plataformas digitales que comparen y gestionen todo el
                    proceso
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 4: Modelo de Negocio */}
        <section className="mb-16" data-id="element-549">
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 md:p-12 border border-purple-100" data-id="element-550">
            <span className="inline-block px-3 py-1 bg-purple-100 text-purple-700 text-xs font-semibold rounded-full mb-4" data-id="element-551">
              MODELO DE NEGOCIO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-552">
              Ganamos cuando tú ganas
            </h2>
            <div className="space-y-6" data-id="element-553">
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-554">
                <h3 className="font-bold text-[#0A1628] mb-3" data-id="element-555">
                  Comisión por colocación
                </h3>
                <p className="text-[#6B7280] mb-4" data-id="element-556">
                  Recibimos una comisión de las instituciones financieras cuando
                  un cliente cierra su crédito a través de nuestra plataforma.
                </p>
                <div className="flex items-center gap-4" data-id="element-557">
                  <div className="flex-1 bg-[#2B5FD9]/10 rounded-lg p-4" data-id="element-558">
                    <p className="text-xs text-[#6B7280] mb-1" data-id="element-559">
                      Ticket promedio
                    </p>
                    <p className="text-2xl font-bold text-[#2B5FD9]" data-id="element-560">
                      UF 3,000
                    </p>
                  </div>
                  <div className="flex-1 bg-[#2B5FD9]/10 rounded-lg p-4" data-id="element-561">
                    <p className="text-xs text-[#6B7280] mb-1" data-id="element-562">
                      Comisión estimada
                    </p>
                    <p className="text-2xl font-bold text-[#2B5FD9]" data-id="element-563">
                      0.5% - 1%
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-564">
                <h3 className="font-bold text-[#0A1628] mb-3" data-id="element-565">
                  100% gratis para el usuario
                </h3>
                <p className="text-[#6B7280]" data-id="element-566">
                  Los compradores no pagan nada. Las instituciones financieras
                  nos pagan por traerles clientes calificados.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 5: Tracción */}
        <section className="mb-16" data-id="element-567">
          <div className="bg-gradient-to-br from-yellow-50 to-amber-50 rounded-2xl p-8 md:p-12 border border-yellow-100" data-id="element-568">
            <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-700 text-xs font-semibold rounded-full mb-4" data-id="element-569">
              TRACCIÓN
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-570">
              Validación temprana del mercado
            </h2>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-571">
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-572">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-573">Beta</p>
                <p className="text-sm text-[#6B7280]" data-id="element-574">
                  Plataforma en desarrollo
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-575">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-576">5+</p>
                <p className="text-sm text-[#6B7280]" data-id="element-577">
                  Instituciones financieras interesadas
                </p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm text-center" data-id="element-578">
                <p className="text-4xl font-bold text-[#2B5FD9] mb-2" data-id="element-579">
                  Q1 2025
                </p>
                <p className="text-sm text-[#6B7280]" data-id="element-580">Lanzamiento objetivo</p>
              </div>
            </div>
          </div>
        </section>

        {/* Slide 6: Equipo */}
        <section className="mb-16" data-id="element-581">
          <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-2xl p-8 md:p-12 border border-gray-200" data-id="element-582">
            <span className="inline-block px-3 py-1 bg-gray-200 text-gray-700 text-xs font-semibold rounded-full mb-4" data-id="element-583">
              EL EQUIPO
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-6" data-id="element-584">
              Experiencia en fintech y proptech
            </h2>
            <p className="text-lg text-[#6B7280] mb-8" data-id="element-585">
              Equipo con experiencia en tecnología financiera, bienes raíces y
              desarrollo de producto.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm" data-id="element-586">
              <p className="text-[#6B7280]" data-id="element-587">
                Información del equipo disponible bajo NDA.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section data-id="element-588">
          <div className="bg-gradient-to-br from-[#2B5FD9] to-[#1E4BB8] rounded-2xl p-8 md:p-12 text-center text-white" data-id="element-589">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-590">
              ¿Listo para revolucionar el mercado hipotecario?
            </h2>
            <p className="text-lg text-white/80 mb-8" data-id="element-591">
              Conversemos sobre cómo Creditual está transformando la experiencia
              de obtener un crédito hipotecario en Chile.
            </p>
            <a href="mailto:hola@creditual.com" className="inline-block px-8 py-4 bg-white text-[#2B5FD9] font-semibold rounded-xl hover:bg-gray-100 transition-colors shadow-lg" data-id="element-592">
              Contactar al equipo
            </a>
          </div>
        </section>
      </div>
    </div>;
}
export default PitchPage;